export default "__VITE_ASSET__CPb036Gq__"